<template>
  <div class="statistics-box relative flex flex-col justify-between" :style="filterseller?'padding-top:0':''">
     <div v-if="filterseller && currentUser && currentUser.type && currentUser.role && currentUser.role.name" class="mb-5 -mx-2 relative border border-gray-600 border-dashed justify-start">
          <div class="flex p-1">
            <div class="ww-3/7" v-if="currentUser.role.name!='Seller' && currentUser.type!='Seller'">
                <div class="flex">
                        <div class="w-10 z-1 pl-1 text-center pointer-events-none flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="15" class="text-gray-600 fill-current" height="15" viewBox="0 0 24 24"><path d="M12 2c2.757 0 5 2.243 5 5.001 0 2.756-2.243 5-5 5s-5-2.244-5-5c0-2.758 2.243-5.001 5-5.001zm0-2c-3.866 0-7 3.134-7 7.001 0 3.865 3.134 7 7 7s7-3.135 7-7c0-3.867-3.134-7.001-7-7.001zm6.369 13.353c-.497.498-1.057.931-1.658 1.302 2.872 1.874 4.378 5.083 4.972 7.346h-19.387c.572-2.29 2.058-5.503 4.973-7.358-.603-.374-1.162-.811-1.658-1.312-4.258 3.072-5.611 8.506-5.611 10.669h24c0-2.142-1.44-7.557-5.631-10.647z"/></svg></div>
                          <v-select
                          @search="getUsersDebance($event,'shipsen')"
                          @input="CheckSellerProducts($event,action,'seller')"
                          label="fullName"
                          placeholder="Seller ..."
                          :options="sellers"
                          v-model="sellerdata"

                          class="text-gray-600 bg-white w-full -ml-10 pl-8 pr-2 py-1 rounded-lg border-2 border-gray-200 outline-none focus:border-indigo-500"
                        
                        ></v-select>
                </div>
            </div>
            <div :class="currentUser.role.name=='Seller' && currentUser.type=='Seller'?'w-11/12':'ww-3/7'">
                <div class="flex">
                    <div class="w-10 z-1 pl-1 text-center pointer-events-none flex items-center justify-center">
                      <svg class="text-gray-600 fill-current" width="15"   height="15" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 24 24"><path d="M11.5 23l-8.5-4.535v-3.953l5.4 3.122 3.1-3.406v8.772zm1-.001v-8.806l3.162 3.343 5.338-2.958v3.887l-8.5 4.534zm-10.339-10.125l-2.161-1.244 3-3.302-3-2.823 8.718-4.505 3.215 2.385 3.325-2.385 8.742 4.561-2.995 2.771 2.995 3.443-2.242 1.241v-.001l-5.903 3.27-3.348-3.541 7.416-3.962-7.922-4.372-7.923 4.372 7.422 3.937v.024l-3.297 3.622-5.203-3.008-.16-.092-.679-.393v.002z"/></svg>
                    </div>
                      <v-select
                       @search="getProducts($event,'shipsen')"
                       @input="CheckSellerProducts($event,action,'product')"
                       label="name"
                       placeholder="Product name ..."
                       :options="products"
                       v-model="productdata"
                      class="text-gray-600 bg-white w-full -ml-10 pl-8 pr-2 py-1 rounded-lg border-2 border-gray-200 outline-none focus:border-indigo-500"
                    ></v-select>
                </div>
            </div>
             <div class="ww-1/7 flex justify-center items-center">
                <svg xmlns="http://www.w3.org/2000/svg" @click="removedata(action)"  class="text-gray-600 fill-current cursor-pointer"  width="20" height="20" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/></svg>
                <!-- <svg :class="!sellerdata && currentUser.role.name!='Seller' && currentUser.type!='Seller'?'btn-disable':''" @click="FindRecordsSellers" xmlns="http://www.w3.org/2000/svg" class="text-gray-600 fill-current cursor-pointer"  width="24" height="24" viewBox="0 0 24 24"><path d="M23.111 20.058l-4.977-4.977c.965-1.52 1.523-3.322 1.523-5.251 0-5.42-4.409-9.83-9.829-9.83-5.42 0-9.828 4.41-9.828 9.83s4.408 9.83 9.829 9.83c1.834 0 3.552-.505 5.022-1.383l5.021 5.021c2.144 2.141 5.384-1.096 3.239-3.24zm-20.064-10.228c0-3.739 3.043-6.782 6.782-6.782s6.782 3.042 6.782 6.782-3.043 6.782-6.782 6.782-6.782-3.043-6.782-6.782zm2.01-1.764c1.984-4.599 8.664-4.066 9.922.749-2.534-2.974-6.993-3.294-9.922-.749z"/></svg> -->
            </div>
          </div>
           <div v-if="filter && timeserchtype=='betweendate'" class="p-1">
           <!-- <div class="inline-block mt-2 ww-45 pr-1">
              <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"><p><label for="date" class="bg-white text-gray-700 px-1">From <span class="text-blue-500">*</span></label></p></div>
                  <p>  <input :name="action" v-model="fromDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="from" type="date"> </p>
              </div>
          </div>
          <div class="inline-block mt-2 ww-45 pr-1">
              <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                  <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"><p><label for="date" class="bg-white text-gray-700 px-1">To <span class="text-blue-500">*</span></label></p></div>
                  <p>  <input :name="action" v-model="toDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="to" type="date"> </p>
              </div>
          </div>
          <div class="inline-block mt-2  text-center">
              <button @click="FindRecordsBetweenDate()" :class="!fromDate || !toDate?'noselect':''" :disabled="!fromDate || !toDate" class="text-white font-light p-1 tracking-wider bg-gray-900 rounded"><i class="material-icons align-middle">search</i></button>
          </div>   -->
          <div class="flex items-center space-x-2 sm:space-x-2">
                 <date-picker placeholder="Range date ..." format="YYYY-MM-DD" type="date" class="w-full-imp  shadow" v-model="fromDate" range></date-picker>
                 <!-- <button @click="FindRecordsBetweenDate()" :disabled="fromDate==null || toDate==null" class="flex px-2 py-2 text-white font-light tracking-wider bg-gray-900 rounded"></button> -->
                 
                 <button @click="FindRecordsBetweenDate()" :class="!fromDate?'noselect':''" :disabled="!fromDate" class="text-white font-light p-1 tracking-wider bg-gray-900 rounded"><i class="material-icons align-middle">search</i></button>
          </div>
      </div>
     </div>
     
    <div v-if="refresh && timeserchtype=='...'" @click="Refrechdata(action)" class="vld-overlay-refrech">
       <div class="vld-background" style="backdrop-filter: blur(2px);"></div>
        <button   class="btnn box flex items-center text-gray-700 dark:text-gray-300 cursor-not-allowed pointer-events-none">
            <img class="analytics-imgg" src="https://img.icons8.com/office/80/000000/refresh--v1.png"/> Refresh 
        </button>
    </div>
   <loading :active.sync="loading" :is-full-page="fullPage"></loading>
      <div class="mb-15">
          <span class="float-right filter-confirm" v-if="filter">
          <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
              <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                <p>
                  <label for="status" class="text-gray-700 px-1"
                    >Date : <span :class="$colors.required">*</span></label
                  >
                </p>
              </div>
            <p>  
            <select  id="type"
                  :name="action"
                  autocomplete="type"
                  @change="ChangeDateConfirmationRate($event)"
                  v-model="timeserchtype"
                  class="py-1 text-xs capitalize px-2 cursor-pointer outline-none block h-full w-full"
                >
                  >
                    <option class="bg-white text-gray-600" value="all">
                    All
                  </option>
                  <option class="bg-white text-gray-600" value="today">
                    Today
                  </option>
                    <option class="bg-white text-gray-600" value="yesterday">Yesterday</option>
                    <option class="bg-white text-gray-600" value="thisweek">This week</option>
                    <option class="bg-white text-gray-600" value="lastweek">Last week</option>
                  <option class="bg-white text-gray-600" value="thismonth">
                    This Month
                  </option>
                  <option class="bg-white text-gray-600" value="lastmonth">
                    Last Month
                  </option> 
                    <option class="bg-white text-gray-600" value="thisyear">
                    This Year
                  </option>
                  <option class="bg-white text-gray-600" value="betweendate">
                      Between date
                    </option>
                </select>
              </p>
          </div>
         
          </span>
          <span class="pull-left ico-icon icon-md icon-primary">
              <div class="text-white p-3 text-center inline-flex items-center justify-center img-size shadow-lg rounded-full"
              :class="[statIconColor]">
               <span v-if="statIconName==='timeline'"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" class="fill-current"><path  d="M3.848 19h-.848c-.796 0-1.559-.316-2.121-.879-.563-.562-.879-1.325-.879-2.121v-3c0-7.175 5.377-13 12-13s12 5.825 12 13v3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879h-.848c-2.69 4.633-6.904 5-8.152 5-1.248 0-5.462-.367-8.152-5zm16.152-5.876c-.601.236-1.269-.18-1.269-.797 0-.304-.022-.61-.053-.915-1.761-.254-3.618-1.926-3.699-3.723-1.315 2.005-4.525 4.17-7.044 4.17 1.086-.699 1.839-2.773 1.903-3.508-.581 1.092-2.898 3.136-4.551 3.487l-.018.489c0 .619-.669 1.032-1.269.797v3.771c.287.256.632.464 1.041.594.225.072.412.224.521.424 2.206 4.046 5.426 4.087 6.438 4.087.929 0 3.719-.035 5.877-3.169-1.071.433-2.265.604-3.759.653-.37.6-1.18 1.016-2.118 1.016-1.288 0-2.333-.784-2.333-1.75s1.045-1.75 2.333-1.75c.933 0 1.738.411 2.112 1.005 1.9-.026 4.336-.334 5.888-2.645v-2.236zm-11-.624c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm6 0c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm5.478-1.5h1.357c-.856-5.118-4.937-9-9.835-9-4.898 0-8.979 3.882-9.835 9h1.357c.52-4.023 3.411-7.722 8.478-7.722s7.958 3.699 8.478 7.722z"></path></svg></span>
               <span v-else-if="statIconName==='delivery'"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" class="fill-current" fill-rule="evenodd" clip-rule="evenodd"><path d="M5 11v1h8v-7h-10v-1c0-.552.448-1 1-1h10c.552 0 1 .448 1 1v2h4.667c1.117 0 1.6.576 1.936 1.107.594.94 1.536 2.432 2.109 3.378.188.312.288.67.288 1.035v4.48c0 1.089-.743 2-2 2h-1c0 1.656-1.344 3-3 3s-3-1.344-3-3h-4c0 1.656-1.344 3-3 3s-3-1.344-3-3h-1c-.552 0-1-.448-1-1v-6h-2v-2h7v2h-3zm3 5.8c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm10 0c.662 0 1.2.538 1.2 1.2 0 .662-.538 1.2-1.2 1.2-.662 0-1.2-.538-1.2-1.2 0-.662.538-1.2 1.2-1.2zm-3-2.8h-10v2h.765c.549-.614 1.347-1 2.235-1 .888 0 1.686.386 2.235 1h5.53c.549-.614 1.347-1 2.235-1 .888 0 1.686.386 2.235 1h1.765v-4.575l-1.711-2.929c-.179-.307-.508-.496-.863-.496h-4.426v6zm1-5v3h5l-1.427-2.496c-.178-.312-.509-.504-.868-.504h-2.705zm-16-3h8v2h-8v-2z"/></svg></span>
               <i v-else class="material-icons">{{ statIconName }}</i>
              </div>
          </span>
          <div class="stats mb-10">
              <h3 class="font-bold mb-1">{{datas.sum||datas.rate}} <sup>{{currency}}</sup> <span style="font-size: 10px;" v-if="statSubtitle1">(Non Generate)</span></h3>
              <div v-if="statSubtitle1" class="flex items-center border-l-2 border-blue-600 dark:border-blue-500 mt-1 pl-1"><span style="font-size: 10px;" class="font-medium">{{datas.sum1}} <sup>{{currency}}</sup> ({{statSubtitle1}}) </span></div>
              <span class="text">{{statSubtitle}}</span> 
              
          </div>
      </div>
      <div  v-if="datas.countAll || datas.countAll==0" class="flex items-center fontsize-11"><div class="w-2 h-2 bg-gray-600 rounded-full mr-1"></div><span class="truncate">{{action=='ConfirmationRate'?'Total Orders':'Total Shippings'}} </span><span class="font-medium ml-auto">{{datas.countAll}} </span></div>
      <div  v-if="action=='ConfirmationRate' && (datas.confirmed || datas.confirmed==0)" class="flex items-center fontsize-11"><div class="w-2 h-2 bg-green-500 rounded-full mr-1"></div><span class="truncate">Confirmed</span><span class="font-medium ml-auto">{{datas.confirmed}} ({{getPercentege(datas.confirmed,datas.countAll)+'%'}})</span></div>
      <div  v-if="action=='ConfirmationRate' && (datas.cancelled || datas.cancelled==0)" class="flex items-center fontsize-11"><div class="w-2 h-2 bg-red-500 rounded-full mr-1"></div><span class="truncate">Cancelled</span><span class="font-medium ml-auto">{{datas.cancelled}} ({{getPercentege(datas.cancelled,datas.countAll)+'%'}})</span></div>
      
      <div class="flex">
             <div class="w-1/2 pr-1">
                 <div  v-if="action=='Delivery' && (datas.received || datas.received==0)" class="flex items-center fontsize-11"><div  class="w-2 h-2 bg-green-500 rounded-full mr-1"></div><span class="truncate">Received</span><span class="font-medium ml-auto">{{datas.received}} ({{getPercentege(datas.received,datas.countAll)+'%'}})</span></div>
                 <div  v-if="action=='Delivery' && (datas.cancelled || datas.cancelled==0)" class="flex items-center fontsize-11"><div  class="w-2 h-2 bg-red-500   rounded-full mr-1"></div><span class="truncate">Cancelled</span><span class="font-medium ml-auto">{{datas.cancelled}} ({{getPercentege(datas.cancelled,datas.countAll)+'%'}})</span></div>
             </div>
             <!-- <div class="w-px  h-12 border border-r border-dashed border-slate-200 dark:border-darkmode-300 mx-4 xl:mx-5"></div> -->
             <div class="w-1/2 pl-1" style="border-left: 1px solid black;">
                 <div  v-if="action=='Delivery' && (datas.paid || datas.paid==0)" class="flex items-center fontsize-11"><div style="background-color: rgb(233, 173, 99);"  class="w-2 h-2 rounded-full mr-1"></div><span class="truncate">Paid</span><span class="font-medium ml-auto">{{datas.paid}} ({{getPercentege(datas.paid,datas.countAll)+'%'}})</span></div>
                 <div  v-if="action=='Delivery' && (datas.processed || datas.processed==0)" class="flex items-center fontsize-11"><div  style="background-color: rgb(187, 7, 233);"  class="w-2 h-2  rounded-full mr-1"></div><span class="truncate">Processed</span><span class="font-medium ml-auto">{{datas.processed}} ({{getPercentege(datas.processed,datas.countAll)+'%'}})</span></div>
             </div>
      </div>

      
     
      <div :id="id"></div>
       
   </div>
</template>
<script>
export default {
  name: "card-stats-v2",
  props: {
    statSubtitle: {
      default: "Traffic",
    },
    loading:{required:false},
    timeserch:{},
    titleRate:{},
    from:{},
    to:{},
    seller:{},
    product:{},
    filter: {
      default: false,
    },
    filterseller: {
      default: false,
    },
    refresh: {
      default: false,
    },
    statTitle: {},
    action: {},
    statArrow: {
      default: "up",
      validator: function (value) {
        // The value must match one of these strings
        return ["up", "down"].indexOf(value) !== -1;
      },
    },
    statPercent: {},
    // can be any of the text color utilities
    // from tailwindcss
    statPercentColor: {
      default: "text-green-500",
    },
    statDescripiron: {},
    statSubtitle1:{type:String},
    id:{type:String},
    color:{type:String},
    currency: {default:false},
    count:{type: Number,default:0},
    datas:{type:Object},
    currentUser:{type:Object},
    warhouse:{type:Object},
    dataChart:{type:Array},
    sellers:{type:Array},
    products:{type:Array},
    countText:{},
    rate:{},
    statIconName: {
      default: "far fa-chart-bar",
    },
    // can be any of the background color utilities
    // from tailwindcss
    statIconColor: {
      type: String,
      default: "bg-red-500",
    },
  },
  data() {
    return {
      fullPage: false,
      timeserchtype:this.timeserch,
      sellerdata:this.seller,
      productdata:this.product,
      myChart: "",
      fromDate:this.from,
      toDate:this.to,
    };
  },
 watch: {
    dataChart: function () {
      if (this.myChart != null) this.myChart.destroy();
      this.drawChart(this.dataChart);
      this.myChart.render();
    },
    'timeserch': function () {
      this.timeserchtype=this.timeserch;
    },
   'seller': function () {
     console.log('seller------',this.seller)
      this.sellerdata=this.seller;
   },
   'product': function () {
     console.log('product------',this.product)
      this.productdata=this.product;
   },
  },
  async mounted(){
    //  var chart = new ApexCharts(document.querySelector("#"+this.id), this.options);
	  //   chart.render();
     await this.drawChart(this.dataChart);
     this.myChart.render();
     if(this.currentUser && this.currentUser.role && this.currentUser.role.name=='Seller' && this.currentUser.type=='Seller') this.sellerdata=this.currentUser;

  },
   methods: {
     getPercentege(countStatus,total){
         return total?Math.round((countStatus * 100) /  total):0;
     },
    FindRecordsBetweenDate: function (val) {
         this.$emit("FindRecordsBetweenDate", this.action,this.fromDate,this.toDate);
    },
    FindRecordsSellers: function (val) {
        this.$emit("FindRecordsSellers", this.action,this.sellerdata,this.productdata);
    },
    getUsersDebance: function (name) {
        this.$emit("getUsersDebance", name);
     }, 
    getProducts: function (name) {
        this.$emit("getProducts", name);
     }, 
    async CheckSellerProducts(seller,action,model){
       this.$emit("CheckSellerProducts", seller,action,model);
    },
    removedata: function (val) {
        this.$emit("removedata", this.action);
     }, 
    drawChart(chartData) {
        var ctx = document.getElementById(this.id);
        this.myChart = new ApexCharts(ctx, {
        chart: {
          height: 35,
          type: 'line',
          zoom: {
            enabled: false
          },
          foreColor: '#4e4e4e',
          toolbar: {
            show: false
          },
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            top: 1,
            left: 1,
            blur: 2,
            opacity: 0.12,
          }
        },
        plotOptions: {
          bar: {
            columnWidth: '10%',
            endingShape: 'rounded',
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 2.5,
          curve: 'straight'
        },
        series: [{
          name: this.statSubtitle,
          data: chartData
        }],
        // xaxis: {
        //   type: 'month',
        //   categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
        // },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function (val) {
              return parseInt(val);
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            gradientToColors: [this.color],
            shadeIntensity: 1,
            type: 'horizontal',
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 80, 100]
          },
        },
        colors: [this.color],
        legend: {
          show: 0,
          position: "top",
          horizontalAlign: "center",
          offsetX: -20,
          fontSize: "12px",
          markers: {
            radius: 50,
            width: 10,
            height: 10
          }
        },
        grid: {
          show: false,
          borderColor: 'rgba(66, 59, 116, 0.12)',
        },
        tooltip: {
          theme: 'dark',
          x: {
            show: false
          },
        }
       });
    },
    ChangeDateConfirmationRate: function (val) { 
      if(val.target.name=="ConfirmationRate")  this.$emit("ChangeDateConfirmationRate", val);
      if(val.target.name=="Delivery") this.$emit("ChangeDateConfirmationDelevry", val);
    },
    Refrechdata: function (val) { 
        this.$emit("Refrechdata", val);
    },
    //  FindRecords: function () {
    //   this.$emit("FindRecords", this.action,this.fromDate,this.toDate);
    // },
   }
};
</script>
<style scoped> 
.text-grey-darker{
  color: #596a73;
    font-weight: 600;
}
.fontsize-11{
  font-size: 11px;
}
.stats  .text{
  color: rgba(118, 118, 118, 1.0);
  font-size: 14px;
  line-height: 23px;
  font-style: normal;
  font-weight: normal;
}
.filter-confirm{
  width: 95px;
}
.statistics-box:before,.statistics-box:after{
  content: "";
  position: absolute;
  background-color: hsl(0deg 0% 70% / 17%);
  right: -40px;
  border-radius: 50%;
}
.statistics-box:after {
    width: 80px;
    height: 80px;
    bottom: 70px;
}
.statistics-box:before {
  width: 100px;
  height: 100px;
  bottom: -7px;
}
.statistics-box {
    background-image: radial-gradient(circle 140px at center,#e0e0da,#ffffff);
    box-shadow: 0 5px 15px rgb(57 98 254 / 2%), 0 3px 6px rgb(117 108 254 / 12%);
    -webkit-box-shadow: 0 5px 15px rgb(57 98 254 / 2%), 0 3px 6px rgb(117 108 254 / 12%);
    -moz-box-shadow: 0 5px 15px rgb(57 98 254 / 2%), 0 3px 6px rgb(117 108 254 / 12%);
    -o-box-shadow: 0 5px 15px rgb(57 98 254 / 2%), 0 3px 6px rgb(117 108 254 / 12%);
    -ms-box-shadow: 0 5px 15px rgb(57 98 254 / 2%), 0 3px 6px rgb(117 108 254 / 12%);
    margin-bottom: 15px;
    border-radius: 7px;
    overflow: hidden;
    position: relative;
    padding: 10px;
    transition: all 0.3s ease-in-out;
    flex: 1 1 auto;
    min-height: 1px;
}
.statistics-box .ico-icon {
    max-width: 60px;
}
.ico-icon {
    position: relative;
}
.icon-primary {
    color: #4d9cf8;
}
.icon-md {
    font-size: 28px;
}
.pull-left {
    float: left;
}
.statistics-box .ico-icon .material-icons {
    position: relative;
    top: -1px;
    font-size: 45px;
}
.statistics-box .stats {
    margin-left: 70px;
}
.mb-30 {
    margin-bottom: 30px;
}
.mb-10 {
    margin-bottom: 10px;
}
.mb-15{
  margin-bottom: 15px;
}
.img-size{
  width: 60px;
  height: 60px;
}

</style>
